var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppLayout",
    {
      attrs: {
        page: "/dashboard",
        pageTitle: "Cross Studio Payroll",
        backLink: "/dashboard/reports",
      },
    },
    [
      _c(
        "v-col",
        { staticClass: "pa-1", attrs: { cols: "12" } },
        [
          _c("Stats", { staticClass: "pb-3", attrs: { stats: _vm.stats } }),
          _vm._v(" "),
          _c(
            "v-card",
            { staticClass: "soli-round" },
            [
              _c(
                "v-container",
                { staticClass: "px-3", attrs: { fluid: "" } },
                [
                  _c("ReportHeader", {
                    attrs: {
                      filter: "",
                      legacyDate: _vm.payDay,
                      dateRange: _vm.dateRange,
                      rangeOptions: {
                        interval:
                          _vm.$page.props.auth.user.selected_location[
                            "pay_int"
                          ],
                        frequency:
                          _vm.$page.props.auth.user.selected_location[
                            "pay_freq"
                          ],
                      },
                      subtitle: "Earnings by Pay Period",
                      reportUrl: "/dashboard/reports/cross-studio-payroll/",
                    },
                    on: {
                      search: function ($event) {
                        _vm.search = $event
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "extendedSubtitle",
                        fn: function () {
                          return [
                            _vm.isProcessed
                              ? _c(
                                  "v-list-item-subtitle",
                                  {
                                    staticClass: "font-bold error--text",
                                    staticStyle: { "white-space": "normal" },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        attrs: {
                                          left: "",
                                          small: "",
                                          color: "error",
                                        },
                                      },
                                      [_vm._v("flag")]
                                    ),
                                    _vm._v(
                                      _vm._s(
                                        `Processed on ${_vm.globalMomentFullDateAtTime(
                                          _vm.processed_at
                                        )}`
                                      )
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "filterItem",
                        fn: function () {
                          return [
                            _c(
                              "v-list",
                              { attrs: { dense: "" } },
                              [
                                _c(
                                  "v-list-item",
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          href: `${_vm.$page.url}?csv=true`,
                                          text: "",
                                          outlined: "",
                                          rounded: "",
                                          block: "",
                                          color: "dark",
                                        },
                                      },
                                      [
                                        _vm._v("Download as CSV"),
                                        _c(
                                          "v-icon",
                                          { attrs: { small: "", right: "" } },
                                          [_vm._v("download")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("v-data-table", {
                    ref: "table",
                    staticClass: "table-nowrap",
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.report,
                      search: _vm.search,
                      "hide-default-footer": "",
                      "disable-pagination": "",
                      "mobile-breakpoint": "0",
                      "item-key": "rate_id",
                      "show-expand": "",
                      expanded: _vm.expanded,
                      "group-by": "location_name",
                    },
                    on: {
                      "update:expanded": function ($event) {
                        _vm.expanded = $event
                      },
                      "click:row": function ($event) {
                        return _vm.$log($event.rate_id)
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: `group.header`,
                          fn: function ({ items, isOpen, toggle }) {
                            return [
                              _c(
                                "th",
                                { attrs: { colspan: _vm.headers.length } },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex font-weight-regular" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex-col align-self-center mr-2",
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { on: { click: toggle } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  isOpen ? "remove" : "add"
                                                ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-item-subtitle",
                                        {
                                          staticClass:
                                            "soli-grey font-weight-bold",
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(items[0].location_name) +
                                              "\n                                "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: `group.summary`,
                          fn: function ({ items }) {
                            return [
                              _c(
                                "div",
                                { attrs: { colspan: _vm.headers.length } },
                                [
                                  _c(
                                    "v-list",
                                    [
                                      _c(
                                        "v-list-item",
                                        [
                                          _c(
                                            "v-list-item-subtitle",
                                            {
                                              staticClass:
                                                "font-weight-black soli-grey",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    `Total Due: ${_vm.formatCurrency(
                                                      items
                                                        .map((e) =>
                                                          Number(e.total_pay)
                                                        )
                                                        .reduce((a, b) => a + b)
                                                    )}`
                                                  )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.user.name`,
                          fn: function ({ item }) {
                            return [
                              !_vm.groupByStaff
                                ? _c("SoliListAvatar", {
                                    attrs: {
                                      avatar: item.user.profile_photo_url,
                                      title: item.user.name,
                                      subtitle: item.user.email,
                                      href: `/profile/${item.staff_id}/manage`,
                                    },
                                  })
                                : _vm._e(),
                            ]
                          },
                        },
                        {
                          key: `item.total_pay`,
                          fn: function ({ item }) {
                            return [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.formatCurrency(item.total_pay)) +
                                  "\n                    "
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.rate_amount`,
                          fn: function ({ item }) {
                            return [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    `${_vm.formatCurrency(
                                      item.rate_amount
                                    )}/hour`
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          },
                        },
                        {
                          key: "expanded-item",
                          fn: function ({ headers, item }) {
                            return [
                              _c(
                                "td",
                                {
                                  staticClass: "ma-3",
                                  attrs: { colspan: headers.length },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "ma-3" },
                                    [
                                      _c("v-simple-table", [
                                        _c("thead", [
                                          _c(
                                            "tr",
                                            _vm._l(
                                              _vm.expandedContent,
                                              function (content) {
                                                return _c(
                                                  "th",
                                                  {
                                                    key: content.text,
                                                    staticClass: "text-left",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                " +
                                                        _vm._s(content.text) +
                                                        "\n                                            "
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("tbody", [
                                          _c(
                                            "tr",
                                            _vm._l(
                                              _vm.expandedContent,
                                              function (content) {
                                                return _c(
                                                  "td",
                                                  {
                                                    key: content.text,
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.$log(
                                                          JSON.parse(
                                                            item[
                                                              `${content.value}_data`
                                                            ]
                                                          ).sort(
                                                            (a, b) =>
                                                              new Date(a[1]) -
                                                              new Date(b[1])
                                                          )
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-chip",
                                                      {
                                                        class: [
                                                          "Group Event",
                                                          "Attended",
                                                          "Late Cancel",
                                                          "No-show",
                                                          "Courtesy Cancel",
                                                        ].includes(content.text)
                                                          ? "soli-attendance-green white--text"
                                                          : null,
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                                    " +
                                                            _vm._s(
                                                              item[
                                                                content.value
                                                              ] ?? 0
                                                            ) +
                                                            "\n                                                "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            0
                                          ),
                                        ]),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }